import type { IconData } from '@stacksjs/iconify-core'

export const calendarAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0zM3 8h2v2H3zm0 4h2v2H3zm12 0h2v2h-2zm0-4h2v2h-2zM7 8h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default calendarAlt
